import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as departmentActions } from '../../../actions/departmentActions';
import { actions as disciplineActions } from '../../../actions/disciplineActions';
import DepartmentForm from '../Identifiers/taskDepartmentForm';
import { DEFAULT_PAGE_SIZE } from '../../../constants/constants';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import Drawer from '../../Common/Drawer/Drawer';
import Icon from '../../Common/Icon';
import Notification from '../../Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import { getDataTableSortFields, getSearchParamSortFields } from '../../../helpers/sortHelper';
import { getNullableOnChangeValue } from '../../../helpers/multiselect';

export class Department extends React.Component {

    constructor(props, context) {
        super(props, context);

        const newDepartment = {
            id: 0,
            name: "",
            isActive: true,
            subscriptionId: props.subscriptionId,
            disciplineId: ""
        };

        this.state = {
            departments: [],
            disciplines: [],
            totalCount: 0,
            isFetching: false,
            isSaving: false,
            selectedDepartment: newDepartment,
            editDepartment: newDepartment,
            selectedDisciplineId: 0,
            newDepartment: newDepartment,
            drawerOpen: false,
            isFormValid: true,
            showInactiveWarning: false,
            searchParams: {
                subscriptionId: props.subscriptionId,
                isActive: true,
                pageSize: DEFAULT_PAGE_SIZE,
                pageNumber: 1,
                sortBy: "name",
                sortDir: "asc",
                name: "",
                disciplineId: 0
            }
        };
        this.search.bind(this);
    }

    async componentDidMount() {
        try {
            this.setState({ isFetching: true });
            const result = await this.props.actions.discipline.listDisciplines({
                subscriptionId: this.props.subscriptionId
            });

            const payload = result.payload;
            if (result.type === types.LIST_DISCIPLINE_SUCCESS) {
                this.setState({ disciplines: payload.disciplines });
            } else if (result.type === types.LIST_DISCIPLINE_FAILURE) {
                Notification("error", "Error Loading Disciplines", payload.message);
            }

            await this.search();
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        }
        finally {
            this.setState({ isFetching: false });
        }
    }

    async search() {
        try {
            this.setState({ isFetching: true });
            const result = await this.props.actions.department.searchDepartments(this.state.searchParams);
            const payload = result.payload;
            if (result.type === types.SEARCH_DEPARTMENT_SUCCESS) {
                this.setState({ departments: payload.results, totalCount: payload.totalCount });
            } else if (result.type === types.SEARCH_DEPARTMENT_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        }
        finally {
            this.setState({ isFetching: false });
        }

    }

    async save() {
        this.setState({ isSaving: true });
        const result = await this.props.actions.department.saveDepartment(this.state.editDepartment)

        if (result.type === types.CREATE_DEPARTMENT_SUCCESS || result.type === types.UPDATE_DEPARTMENT_SUCCESS) {
            Notification("success", "Save Successful", "Department saved successfully")
            this.setState({ drawerOpen: false });
            this.setState({ searchParams: { ...this.state.searchParams, pageNumber: 1 } }, () => {
                this.search();
            });
        } else if (result.type === types.UPDATE_DEPARTMENT_FAILURE || result.type === types.CREATE_DEPARTMENT_FAILURE) {
            this.setState({ errorMessage: result.payload.message });
            Notification("error", "An Error Occurred", result.payload.message)
        }
        this.setState({ isSaving: false });
    }

    filterNameChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, name: e.target.value } });
    }

    keyUpName = (e) => {
        if (e.keyCode == 13) {
            this.search();
        }
    }

    filterByDiscipline = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, disciplineId: e.value } }, () => {
            this.search();
        });
    }

    onSearchBlur = () => {
        this.search();
    }

    onActiveChange = (e) => {
        const selectedValue = getNullableOnChangeValue(e);
    
        this.setState(prevState => ({
            searchParams: {
                ...prevState.searchParams,
                isActive: selectedValue
            }
        }), () => {
            this.search();
        });
    }

    onPageChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, pageNumber: (e.page + 1) } }, () => {
            this.search();
        });
    }

    onAddNew = () => {

        if (this.state.disciplines.length <= 0) {
            Notification("error", "No Disciplines", "You must first create at least 1 Discipline to add a Department.");
            return;
        }
        let dp = this.state.newDepartment;
        if (this.state.selectedDisciplineId == 0) {
            dp.disciplineId = this.state.disciplines[0].id;
            this.setState({ selectedDisciplineId: dp.disciplineId });
        } else {
            dp.disciplineId = this.state.selectedDisciplineId;
        }

        this.setState({ editDepartment: dp, drawerOpen: true, errorMessage: "", isFormValid: true, showInactiveWarning: false });
    }

    onFormChange = (name, value) => {
        if (name === "disciplineId") {
            // remember the last discipline selected as a convenience to the user
            this.setState({ editDepartment: { ...this.state.editDepartment, [name]: value }, selectedDisciplineId: value });
        } else if (name == "isActive" && value == false && this.state.editDepartment.id != 0) {
            this.setState({ editDepartment: { ...this.state.editDepartment, [name]: value }, showInactiveWarning: true });
        } else {
            this.setState({ editDepartment: { ...this.state.editDepartment, [name]: value }, showInactiveWarning: false });
        }
    }

    // ------- Drawer
    saveClick = () => {

        if (this.state.editDepartment.name.trim().length < 1 || this.state.editDepartment.disciplineId <= 0) {
            this.setState({ isFormValid: false });
            return;
        }

        this.setState({ isFormValid: true });
        this.save();
    }

    cancelClick = () => {
        this.setState({ drawerOpen: false });
    }

    selectDepartment = async (e) => {
        let department = e.value;
        try {
            const result = await this.props.actions.department.loadDepartment(department.id);
            const payload = result.payload;
            if (result.type === types.LOAD_DEPARTMENT_SUCCESS) {
                department = { ...department, ...result.payload };
            } else if (result.type === types.LOAD_DEPARTMENT_FAILURE) {
                Notification("error", "Error Loading Disciplines", payload.message);
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        }
        this.setState({ selectedDepartment: department, editDepartment: department, drawerOpen: true, errorMessage: "", isFormValid: true, showInactiveWarning: false });
    }

    // ------- Drawer
    actionTemplate = (rowData) => {
        if (rowData.isActive) {
            return <div className="text-success text-center"><Icon name="check-circle" /></div>;
        } else {
            return <div className="text-danger text-center"><Icon name="times-circle" /></div>;
        }
    }

    disciplineOptions = () => {
        let options = [
            { label: "All", value: 0 }
        ];

        for (let i = 0; i < this.state.disciplines.length; i++) {
            options.push({ label: this.state.disciplines[i].name, value: this.state.disciplines[i].id });
        }
        return options;
    }

    onSort = ({ sortField, sortOrder }) => {
        const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
        if (sortBy !== this.state.searchParams.sortBy || sortDir !== this.state.searchParams.sortDir) {
            this.setState({
                searchParams: {
                    ...this.state.searchParams,
                    sortBy: sortBy,
                    sortDir: sortDir
                }
            }, this.search);
        }
    }

    render() {

        const activeOptions = [
            { label: "Yes", value: true },
            { label: "No", value: false },
            { label: "All", value: null }
        ];
        
        const activeFilter = (
                            <Dropdown
                                className="ui-column-filter"
                                value={this.state.searchParams.isActive}
                                options={activeOptions}
                                optionLabel="label"
                                optionValue="value"
                                onChange={this.onActiveChange}
                                placeholder="Select an option"
                            />
                        );

        const nameFilterElement =
            <input type="text" className="p-inputtext" placeholder="Filter by Name" size="50" onBlur={this.onSearchBlur} onChange={this.filterNameChange} onKeyUp={this.keyUpName} value={this.state.searchParams.name} />
            ;


        const disciplineFilter = <Dropdown className="ui-column-filter" style={{ width: '100%' }} value={this.state.searchParams.disciplineId} options={this.disciplineOptions()} onChange={this.filterByDiscipline} />
        const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);

        return (
            <div>
                {
                    this.state.drawerOpen
                        ?
                        <Drawer isWide={false} title="Department" onSaveClick={this.saveClick} onCancelClick={this.cancelClick}>
                            <DepartmentForm
                                disciplines={this.state.disciplines}
                                department={this.state.editDepartment}
                                actions={this.props.actions.department}
                                onFormChange={this.onFormChange}
                                isFormValid={this.state.isFormValid}
                                showWarning={this.state.showInactiveWarning}
                                onSubmit={this.saveClick} />
                        </Drawer>
                        :
                        null
                }
                <LoadingIndicator isLoading={this.state.isSaving || this.state.isFetching} hideWhileLoading={true}>
                    <div>
                        <div className="identifier-header">
                            <div className="title">Department</div>
                            <div className="close">
                                <button type="button" onClick={this.props.onClose} alt="close popup"><Icon name="times" /></button>
                            </div>
                        </div>

                        <div className="identifier-add-new">
                            <div className="col-sm-12">
                                <button id="addNew" type="button" className="btn btn-primary" onClick={this.onAddNew} alt="close popup"><span className="me-2">Add New</span><Icon name="plus-circle" /></button>
                            </div>
                        </div>

                        <div className="identifier-results-table">

                            <DataTable
                                filterDisplay="row"
                                className="p-datatable-sm p-datatable-striped"
                                value={this.state.departments}
                                selectionMode="single"
                                selection={this.state.selectedDepartment}
                                onSelectionChange={this.selectDepartment}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                onSort={this.onSort}
                            >
                                <Column field="name" header="Name" sortable={true} filter={true} filterElement={nameFilterElement} />
                                <Column field="disciplineName" header="Discipline" sortable={true} filter={true} filterElement={disciplineFilter} />
                                <Column field="isActive" header="Active" sortable={true} body={this.actionTemplate} style={{ width: '120px' }} filter={true} filterElement={activeFilter} />
                            </DataTable>
                            {
                                this.state.totalCount > this.state.searchParams.pageSize &&
                                <Paginator
                                    rows={this.state.searchParams.pageSize}
                                    totalRecords={this.state.totalCount}
                                    first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
                                    onPageChange={this.onPageChange} />
                            }
                            <div className="results-count">Total records: {this.state.totalCount}</div>
                        </div>
                    </div>
                </LoadingIndicator>
            </div>
        );
    }

}

Department.propTypes = {
    subscriptionId: PropTypes.number.isRequired,
    actions: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            department: bindActionCreators(departmentActions, dispatch),
            discipline: bindActionCreators(disciplineActions, dispatch)
        }

    };
}

export default connect(null, mapDispatchToProps)(Department);
